/*globals define */

define('jQPlugins/perfect-scrollbar',[
	"jQuery",
	'jQPlugins/jquery.mousewheel'
], function (jQuery) {

	/* Copyright (c) 2012 HyeonJe Jun (http://github.com/noraesae)
	 * Licensed under the MIT License
	 */
	((function($) {

		// The default settings for the plugin
		var defaultSettings = {
			wheelSpeed: 10,
			wheelPropagation: false
		},
		$window = $(window),
		viewportLeft = ($window.scrollLeft() || 0);

		$.fn.perfectScrollbar = function(suppliedSettings, option) {

			// Use the default settings
			var settings = $.extend( true, {}, defaultSettings);
			if (typeof suppliedSettings === "object") {
				// But over-ride any supplied
				$.extend( true, settings, suppliedSettings );
			} else {
				// If no settings were supplied, then the first param must be the option
				option = suppliedSettings;
			}

			if(option === 'update') {
				if($(this).data('perfect_scrollbar_update')) {
					$(this).data('perfect_scrollbar_update')();
				}
				return $(this);
			}
			else if(option === 'destroy') {
				if($(this).data('perfect_scrollbar_destroy')) {
					$(this).data('perfect_scrollbar_destroy')();
				}
				return $(this);
			}
			else if(option === 'freezeX') {
				if($(this).data('perfect_scrollbar_freezerX')) {
					$(this).data('perfect_scrollbar_freezerX')(true);
				}
				return $(this);
			}
			else if(option === 'thawX') {
				if($(this).data('perfect_scrollbar_freezerX')) {
					$(this).data('perfect_scrollbar_freezerX')(false);
				}
				return $(this);
			}

			if($(this).data('perfect_scrollbar')) {
				// if there's already perfect_scrollbar
				return $(this).data('perfect_scrollbar');
			}


			var $this = $(this).addClass('ps-container'),
				$content = $(this).children(),
				$scrollbar_x = $("<div class='ps-scrollbar-x'></div>").appendTo($this),
				$scrollbar_y = $("<div class='ps-scrollbar-y'></div>").appendTo($this),
				container_width,
				container_height,
				content_width,
				content_height,
				scrollbar_x_width,
				scrollbar_x_left,
				scrollbar_x_bottom = parseInt($scrollbar_x.css('bottom'), 10),
				scrollbar_y_height,
				scrollbar_y_top,
				scrollbar_y_right = parseInt($scrollbar_y.css('right'), 10),
				scrollbar_y_height_to_use = 0,
				min_bar_size = (settings.minScrollBarSize && $.isNumeric(settings.minScrollBarSize) === true ? settings.minScrollBarSize : 0),
				using_min_bar_size = false,
				frozenX = false,
				V_SCROLL_ACTION_COMPENSATOR = 50;  //some content will be hidden without this compensator.

				if(min_bar_size > 60) {
					min_bar_size = 60;
				}

			var updateContentScrollTop = function() {
				var scroll_top,
					y_top = scrollbar_y_top,
					isAtLowerTrack = scrollbar_y_top > (container_height * 0.7);

				//this method is called when user grabs the vertical bar and slide
				//we need to compensate the space because of minimum-bar-size feature.
				if(using_min_bar_size === true && isAtLowerTrack === true) {
					y_top = y_top + min_bar_size;
				}

				scroll_top = parseInt(y_top * content_height / container_height, 10);

				if (isAtLowerTrack === true) {
					scroll_top = scroll_top + V_SCROLL_ACTION_COMPENSATOR;
				}

				$this.scrollTop(scroll_top);
				$scrollbar_x.css({bottom: scrollbar_x_bottom - scroll_top});
			};

			var updateContentScrollLeft = function() {
				var scroll_left = parseInt(scrollbar_x_left * content_width / container_width, 10);
				$this.scrollLeft(scroll_left);
				$scrollbar_y.css({right: scrollbar_y_right - scroll_left});
			};

			var getMaxVerticalScrollTop = function(compensator) {
				var buffer = (compensator && $.isNumeric(compensator) === true) ? compensator : 0;
				return $content.outerHeight(false) - $this.height() + buffer;
			};

			var updateBarSizeAndPositionXUnfrozen = function(needCompensator) {
				var is_vertical_scroll_visible = false,
					y_top,
					max_scrollTop;

				container_width = $this.width();
				container_height = $this.height();
				content_width = $content.outerWidth(false);
				content_height = $content.outerHeight(false);

				if(container_width < content_width) {
					scrollbar_x_width = parseInt(container_width * container_width / content_width, 10);
					scrollbar_x_left = parseInt($this.scrollLeft() * container_width / content_width, 10);
				}
				else {
					scrollbar_x_width = 0;
					scrollbar_x_left = 0;
					$this.scrollLeft(0);
				}
				if(container_height < content_height) {
					scrollbar_y_height = parseInt(container_height * container_height / content_height, 10);
					is_vertical_scroll_visible = true;
					scrollbar_y_top = parseInt($this.scrollTop() * container_height / content_height, 10);

					max_scrollTop = (needCompensator === true ? getMaxVerticalScrollTop(V_SCROLL_ACTION_COMPENSATOR) : getMaxVerticalScrollTop(0));
					if ($this.scrollTop() > max_scrollTop) {
						$this.scrollTop(max_scrollTop);
					}
				}
				else {
					scrollbar_y_height = 0;
					$this.scrollTop(0);
				}

				if(scrollbar_y_top >= container_height - scrollbar_y_height) {
					scrollbar_y_top = container_height - scrollbar_y_height;
				}

				if(scrollbar_x_left >= container_width - scrollbar_x_width) {
					scrollbar_x_left = container_width - scrollbar_x_width;
				}

				scrollbar_y_height_to_use = scrollbar_y_height;

				y_top = scrollbar_y_top + $this.scrollTop();

				using_min_bar_size = false;
				if (is_vertical_scroll_visible === true) {
					//we enforce the visual minimum ONLY if the v-scrollbar is supposed to be visible.
					if (scrollbar_y_height_to_use < min_bar_size) {
						scrollbar_y_height_to_use = min_bar_size;
						using_min_bar_size = true;

						if(y_top > (content_height * 0.7)) {
							//we need to make some visual adjustment at the later part of the scroll track so that
							// (a) we have accurate visual position (b) the bar does not go beyond the visible area.
							y_top = y_top - (scrollbar_y_height_to_use * 0.6);
						}
					}
				}

				$scrollbar_x.css({left: scrollbar_x_left + $this.scrollLeft(), bottom: scrollbar_x_bottom - $this.scrollTop(), width: scrollbar_x_width});
				$scrollbar_y.css({top: y_top, right: scrollbar_y_right - $this.scrollLeft(), height: scrollbar_y_height_to_use});
			};

			var updateBarSizeAndPositionXFrozen = function () {
				var is_vertical_scroll_visible = false,
					y_top,
					max_scrollTop;

				container_width = $this.width();
				container_height = $this.height();
				content_width = $content.outerWidth(false);
				content_height = $content.outerHeight(false);

				if(container_width < content_width) {
					scrollbar_x_width = parseInt(container_width * container_width / content_width, 10);
					scrollbar_x_left = parseInt($this.scrollLeft() * container_width / content_width, 10);
				}
				else {
					scrollbar_x_width = 0;
					scrollbar_x_left = 0;
					$this.scrollLeft(0);
				}
				if(container_height < content_height) {
					scrollbar_y_height = parseInt(container_height * container_height / content_height, 10);
					is_vertical_scroll_visible = true;
					scrollbar_y_top = parseInt($this.scrollTop() * container_height / content_height, 10);

					max_scrollTop = (needCompensator === true ? getMaxVerticalScrollTop(V_SCROLL_ACTION_COMPENSATOR) : getMaxVerticalScrollTop(0));
					if ($this.scrollTop() > max_scrollTop) {
						$this.scrollTop(max_scrollTop);
					}
				}
				else {
					scrollbar_y_height = 0;
					$this.scrollTop(0);
				}

				if(scrollbar_y_top >= container_height - scrollbar_y_height) {
					scrollbar_y_top = container_height - scrollbar_y_height;
				}

				if(scrollbar_x_left >= container_width - scrollbar_x_width) {
					scrollbar_x_left = container_width - scrollbar_x_width;
				}

				scrollbar_y_height_to_use = scrollbar_y_height;

				y_top = scrollbar_y_top + $this.scrollTop();

				using_min_bar_size = false;
				if (is_vertical_scroll_visible === true) {
					//we enforce the visual minimum ONLY if the v-scrollbar is supposed to be visible.
					if (scrollbar_y_height_to_use < min_bar_size) {
						scrollbar_y_height_to_use = min_bar_size;
						using_min_bar_size = true;

						if(y_top > (content_height * 0.7)) {
							//we need to make some visual adjustment at the later part of the scroll track so that
							// (a) we have accurate visual position (b) the bar does not go beyond the visible area.
							y_top = y_top - (scrollbar_y_height_to_use * 0.6);
						}
					}
				}

				$scrollbar_x.css({left: scrollbar_x_left - viewportLeft, width: scrollbar_x_width});
				$scrollbar_y.css({top: y_top, right: scrollbar_y_right - $this.scrollLeft(), height: scrollbar_y_height_to_use});
			};

			var updateBarSizeAndPosition = updateBarSizeAndPositionXUnfrozen;

			var moveBarXUnfrozen = function(current_left, delta_x) {
				var new_left = current_left + delta_x,
					max_left = container_width - scrollbar_x_width;

				if(new_left < 0) {
					scrollbar_x_left = 0;
				}
				else if(new_left > max_left) {
					scrollbar_x_left = max_left;
				}
				else {
					scrollbar_x_left = new_left;
				}
				$scrollbar_x.css({left: scrollbar_x_left + $this.scrollLeft()});
			};

			var moveBarXFrozen = function(current_left, delta_x) {
				var new_left = current_left + delta_x,
					max_left = container_width - scrollbar_x_width;

				if(new_left < 0) {
					scrollbar_x_left = 0;
				}
				else if(new_left > max_left) {
					scrollbar_x_left = max_left;
				}
				else {
					scrollbar_x_left = new_left;
				}
				$scrollbar_x.css({left: scrollbar_x_left - viewportLeft});
			};

			var moveBarX = moveBarXUnfrozen;

			var calculateScrollBarYTop = function(current_top, delta_y) {
				var new_top = current_top + delta_y,
					max_top = container_height - scrollbar_y_height;

				if(new_top < 0) {
					scrollbar_y_top = 0;
				}
				else if(new_top > max_top) {
					scrollbar_y_top = max_top;
				}
				else {
					scrollbar_y_top = new_top;
				}
			};

			var moveBarY = function(current_top, delta_y) {
				var new_top = current_top + delta_y,
					max_top = container_height - scrollbar_y_height,
					max_top_for_display = container_height - scrollbar_y_height_to_use,
					scrollbar_y_top_for_display;

				if(new_top < 0) {
					scrollbar_y_top_for_display = 0;
				}
				else if(new_top > max_top) {
					scrollbar_y_top_for_display = max_top_for_display;
				}
				else {
					scrollbar_y_top_for_display = new_top;
				}
				$scrollbar_y.css({top: scrollbar_y_top_for_display + $this.scrollTop()});
			};

			var bindMouseScrollXHandler = function() {
				var current_left,
					current_page_x;

				$scrollbar_x.bind('mousedown.perfect-scroll', function(e) {
					current_page_x = e.pageX;
					current_left = $scrollbar_x.position().left;
					$scrollbar_x.addClass('in-scrolling');
					e.stopPropagation();
					e.preventDefault();
				});

				$(document).bind('mousemove.perfect-scroll', function(e) {
					if($scrollbar_x.hasClass('in-scrolling')) {
						moveBarX(current_left, e.pageX - current_page_x);
						updateContentScrollLeft();
						e.stopPropagation();
						e.preventDefault();
					}
				});

				$(document).bind('mouseup.perfect-scroll', function(e) {
					if($scrollbar_x.hasClass('in-scrolling')) {
						$scrollbar_x.removeClass('in-scrolling');
					}
				});
			};

			var bindMouseScrollYHandler = function() {
				var current_top,
					current_page_y;

				$scrollbar_y.bind('mousedown.perfect-scroll', function(e) {
					current_page_y = e.pageY;
					current_top = $scrollbar_y.position().top;
					$scrollbar_y.addClass('in-scrolling');
					e.stopPropagation();
					e.preventDefault();
				});

				$(document).bind('mousemove.perfect-scroll', function(e) {
					if($scrollbar_y.hasClass('in-scrolling')) {
						var y_delta = e.pageY - current_page_y;

						$scrollbar_y.hide();
						calculateScrollBarYTop(current_top, y_delta);
						updateContentScrollTop();
						moveBarY(current_top, y_delta);
						$scrollbar_y.show();

						e.stopPropagation();
						e.preventDefault();
					}
				});

				$(document).bind('mouseup.perfect-scroll', function(e) {
					if($scrollbar_y.hasClass('in-scrolling')) {
						$scrollbar_y.removeClass('in-scrolling');
					}
				});
			};

			// bind handlers
			var bindMouseWheelHandler = function() {
				var shouldPreventDefault = function(deltaX, deltaY) {
					var scrollTop = $this.scrollTop();
					if(scrollTop === 0 && deltaY > 0 && deltaX === 0) {
						return !settings.wheelPropagation;
					}
					else if(scrollTop >= content_height - container_height && deltaY < 0 && deltaX === 0) {
						return !settings.wheelPropagation;
					}

					var scrollLeft = $this.scrollLeft();
					if(scrollLeft === 0 && deltaX < 0 && deltaY === 0) {
						return !settings.wheelPropagation;
					}
					else if(scrollLeft >= content_width - container_width && deltaX > 0 && deltaY === 0) {
						return !settings.wheelPropagation;
					}
					return true;
				};

				$this.mousewheel(function(e, delta, deltaX, deltaY) {
					var scrolltop_new = $this.scrollTop() - (deltaY * settings.wheelSpeed),
						max_scrolltop = getMaxVerticalScrollTop(V_SCROLL_ACTION_COMPENSATOR);

					if (scrolltop_new > max_scrolltop) {
						scrolltop_new = max_scrolltop;
					}

					$this.scrollTop(scrolltop_new);

					$this.scrollLeft($this.scrollLeft() + (deltaX * settings.wheelSpeed));

					// update bar position
					updateBarSizeAndPosition(true);

					if(shouldPreventDefault(deltaX, deltaY)) {
						e.preventDefault();
					}
				});
			};

			// bind mobile touch handler
			var bindMobileTouchHandler = function() {
				var applyTouchMove = function(difference_x, difference_y) {
					$this.scrollTop($this.scrollTop() - difference_y);
					$this.scrollLeft($this.scrollLeft() - difference_x);

					// update bar position
					updateBarSizeAndPosition(true);
				};

				var start_coords = {},
					start_time = 0,
					speed = {},
					breaking_process = null;

				$this.bind("touchstart.perfect-scroll", function(e) {
					var touch = e.originalEvent.targetTouches[0];

					start_coords.pageX = touch.pageX;
					start_coords.pageY = touch.pageY;

					start_time = (new Date()).getTime();

					if (breaking_process !== null) {
						clearInterval(breaking_process);
					}
				});
				$this.bind("touchmove.perfect-scroll", function(e) {
					var touch = e.originalEvent.targetTouches[0];

					var current_coords = {};
					current_coords.pageX = touch.pageX;
					current_coords.pageY = touch.pageY;

					var difference_x = current_coords.pageX - start_coords.pageX,
						difference_y = current_coords.pageY - start_coords.pageY;

					applyTouchMove(difference_x, difference_y);
					start_coords = current_coords;

					var current_time = (new Date()).getTime();
					speed.x = difference_x / (current_time - start_time);
					speed.y = difference_y / (current_time - start_time);
					start_time = current_time;

					e.preventDefault();
				});
				$this.bind("touchend.perfect-scroll", function(e) {
					breaking_process = setInterval(function() {
						if(Math.abs(speed.x) < 0.01 && Math.abs(speed.y) < 0.01) {
							clearInterval(breaking_process);
							return;
						}

						applyTouchMove(speed.x * 30, speed.y * 30);

						speed.x *= 0.8;
						speed.y *= 0.8;
					}, 10);
				});
			};

			var fixedPositionAdjustment = function () {
				viewportLeft = $window.scrollLeft();
				updateBarSizeAndPosition();
			};

			var setFrozenX = function (value) {
				if (frozenX == value) {
					return;
				}

				frozenX = value;
				if (frozenX) {
					$window.on('scroll', fixedPositionAdjustment);
					moveBarX = moveBarXFrozen;
					updateBarSizeAndPosition = updateBarSizeAndPositionXFrozen;
				}
				else {
					$window.off('scroll', fixedPositionAdjustment);
					moveBarX = moveBarXUnfrozen;
					updateBarSizeAndPosition = updateBarSizeAndPositionXUnfrozen;
				}
				$this.data('perfect_scrollbar_update', updateBarSizeAndPosition);

				fixedPositionAdjustment();
			};

			var destroy = function() {
				$scrollbar_x.remove();
				$scrollbar_y.remove();
				$this.unbind('mousewheel');
				$this.unbind('touchstart.perfect-scroll');
				$this.unbind('touchmove.perfect-scroll');
				$this.unbind('touchend.perfect-scroll');
				$(window).unbind('mousemove.perfect-scroll');
				$(window).unbind('mouseup.perfect-scroll');
				$this.data('perfect_scrollbar', null);
				$this.data('perfect_scrollbar_update', null);
				$this.data('perfect_scrollbar_destroy', null);
				$this.data('perfect_scrollbar_freezerX', null);
				$window.off('scroll', fixedPositionAdjustment);
			};

			var isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

			var initialize = function() {
				moveBarX = moveBarXUnfrozen;
				updateBarSizeAndPosition = updateBarSizeAndPositionXUnfrozen;
				updateBarSizeAndPosition();
				bindMouseScrollXHandler();
				bindMouseScrollYHandler();
				if(isMobile) bindMobileTouchHandler();
				if($this.mousewheel) bindMouseWheelHandler();
				$this.data('perfect_scrollbar', $this);
				$this.data('perfect_scrollbar_update', updateBarSizeAndPosition);
				$this.data('perfect_scrollbar_destroy', destroy);
				$this.data('perfect_scrollbar_freezerX', setFrozenX);
			};

			// initialize
			initialize();

			return $this;
		};
	})(jQuery));

});
